/**
 * @ngdoc directive
 * @module app
 * @name app:videoManager
 * @scope
 * @restrict E
 * @description
 * Sizes videos to ensure they fit on screen and wires up modal event handling.
 * @param {boolean=} fitToScreen Forces the video to fill the viewport. Even if this is false, the video's height will be restricted to ensure the video isn't taller than the viewport.
 * @param {string=} provider The name of the video service the video part of. Used to determine how the video events should be wired up.
 * @param {string=} videoId Unique id used to identify the video.
 */
(function () {
    angular.module('app')
        .directive('videoManager', videoManager);

    var id = 0;
    videoManager.$inject = ['$window', '$timeout', 'videoProviders'];
    function videoManager($window, $timeout, videoProviders) {
        var directive = {
            restrict: 'A',
            scope: {
                fitToScreen: '=?',
                videoId: '@?',
                provider: '@?',
                autoplay: '=?',
                loop: '=?'
            },
            require: '?^^stickyManager',
            link: link
        };
        return directive;
        function link($scope, $element, $attrs, stickyManager) {
            var provider;
            var instanceId = id++;
            var styleName = $scope.fitToScreen ? 'height' : 'max-height';
            var win = angular.element($window).on('scroll.videoManager' + instanceId, configure).on('resize.videoManager' + instanceId, configure);
            
            function configure() {
                var headerSize = stickyManager ? stickyManager.getStickPoint() : 0;
                $element.removeAttr('style');
                $element.css(Foundation.MediaQuery.current === 'small' ? 'height' : styleName, 'calc(100vh - ' + headerSize + 'px)');
                if ($scope.autoplay && provider && provider.ready) {
                    var boundingRect = $element[0].getBoundingClientRect();
                    if (boundingRect.bottom > headerSize && boundingRect.top <= $window.innerHeight) {
                        provider.play();
                    }
                    else {
                        provider.pause();
                    }
                }

            }
            $timeout(configure);

            if ($scope.videoId) {
                provider = videoProviders.get($scope.provider);
                if (provider !== null) {
                    provider.init('player-' + $scope.videoId, $scope.loop).then(function () {
                        configure();
                        var target = angular.element('#video-' + $scope.videoId);
                        target.on('closed.zf.reveal', function () {
                            provider.stop();
                        }).on('open.zf.reveal', function () {
                            provider.play();
                        });
                    });
                }
            }

            $scope.$on('slideChange', function (event, data) {
                if (provider && provider.ready) {
                    if (data.index === $scope.$parent.$index) {
                        provider.play();
                    }
                    else {
                        provider.pause();
                    }
                }
            });

            $scope.$on('pauseVideo', function () {
                if (provider && provider.ready) {
                    provider.pause();
                }
            });

            $scope.$on('$destroy', function () {
                win.off('scroll.videoManager' + instanceId).off('resize.videoManager' + instanceId);
            });
        }
    }
})();